const global = {
    state: {
        config: {},
        tabIndex: null,
        shutdown: false,
        priceRate: [], // 计价费率
        zendeskData: {
            "guanyuwomen": {
                "zh_cn": "https://1329566.s5.udesk.cn/hc/sections/564",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/10626469683345",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/10626469683345",
                "pt": "https://biking.zendesk.com/hc/pt/sections/10626469683345"
            },
            "caozuozhinan": {
                "zh_cn": "https://1329566.s5.udesk.cn/hc/sections/572",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/10621702835985",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/10621702835985",
                "pt": "https://biking.zendesk.com/hc/pt/sections/10621702835985"
            },
            "feilvshuming": {
                "zh_cn": "https://1329566.s5.udesk.cn/hc/articles/1294",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/10627173177489",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/10627173177489",
                "pt": "https://biking.zendesk.com/hc/pt/sections/10627173177489"
            },
            "gonggaoshuoming": {
                "zh_cn": "https://1329566.s5.udesk.cn/hc/categories/436",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/10581658578961",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/10581658578961",
                "pt": "https://biking.zendesk.com/hc/pt/sections/10581658578961"
           },
            "yonghuxuzhi": {
                "zh_cn": "https://1329566.s5.udesk.cn/hc/categories/439",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/10621701457937",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/10621701457937",
                "pt": "https://biking.zendesk.com/hc/pt/sections/10621701457937"
            },
            "fengxiantishi": {
                "zh_cn": "https://1329566.s5.udesk.cn/hc/sections/566",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/11064286527121",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/11064286527121",
                "pt": "https://biking.zendesk.com/hc/pt/sections/11064286527121"
            },
            "xieyiliebiao": {
                "zh_cn": "https://1329566.s5.udesk.cn/hc/articles/1308",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/11064489204369",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/11064489204369",
                "pt": "https://biking.zendesk.com/hc/pt/sections/11064489204369"
            },
            "bangzhuzhongxin": {
                "zh_cn": "https://1329566.s5.udesk.cn/hc_mobile",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw",
                "en_us": "https://biking.zendesk.com/hc/en-us",
                "pt": "https://biking.zendesk.com/hc/pt"
            },
            "gonggao": {
                "zh_cn": "https://1329566.s5.udesk.cn/hc_mobile/category/436",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/10581658578961",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/10581658578961",
                "pt": "https://biking.zendesk.com/hc/pt/sections/10581658578961"
            },
            "renwushuoming ": {
                "zh_cn": "https://1329566.s5.udesk.cn/hc_mobile/article/1326",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/10626929152017",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/10626929152017",
                "pt": "https://biking.zendesk.com/hc/pt/sections/10626929152017"
            },
            "changjianwenti": {
                "zh_cn": "https://1329566.s5.udesk.cn/hc_mobile/article/1344",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/16886318519057",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/16886318519057",
                "pt": "https://biking.zendesk.com/hc/pt/sections/16886318519057"
            },
            "daidanxieyi": {
                "zh_cn": "https://biking.zendesk.com/hc/zh-cn/articles/13398583675537",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/13398583675537",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/13398583675537",
                "pt": "https://biking.zendesk.com/hc/pt/sections/13398583675537"
            },
            "zhucexieyi": {
                "zh_cn": "https://biking.zendesk.com/hc/zh-cn/articles/11064572291473",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/11064572291473",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/11064572291473",
                "pt": "https://biking.zendesk.com/hc/pt/sections/11064572291473"
            },
        
            "yingyongxiazai": {
                "zh_cn": "https://biking.zendesk.com/hc/zh-cn/articles/11064572291473",
                "zh_tw": "https://biking.zendesk.com/hc/zh-tw/sections/11064572291473",
                "en_us": "https://biking.zendesk.com/hc/en-us/sections/11064572291473",
                "pt": "https://biking.zendesk.com/hc/pt/sections/11064572291473"
            },
            "zaixiankefu":{
                "zh_cn": "https://1329566.s5.udesk.cn/im_client/?web_plugin_id=1676&language=zh-cn",
                "zh_tw": "https://1329566.s5.udesk.cn/im_client/?web_plugin_id=1676&language=zh-TW",
                "en_us": "https://1329566.s5.udesk.cn/im_client/?web_plugin_id=1676&language=en-us",
                "pt": "https://1329566.s5.udesk.cn/im_client/?web_plugin_id=1676&language=pt"
            },
        
            "yonghuzhuxiao": {
                "zh_cn": "https://bikingex.hk.mikecrm.com/LZy1Rux",
                "zh_tw": "https://bikingex.hk.mikecrm.com/kd8bp0X",
                "en_us": "https://bikingex.hk.mikecrm.com/77zRl1y",
                "pt": "https://bikingex.hk.mikecrm.com/ObLvNUn"
            }
        }
    },
    mutations: {
        SET_ZENDESK_DATA: (state, item) =>{
          state.zendeskData = {...item}
        },
        setGlobalConfig: (state, item) => {
            state.config = {
                ...(state.config || {}),
                ...item
            }
        },
        setTabIndex: (state, item) => {
            state.tabIndex = item
        },
        setShutdown: (state, Boolean) => {
            state.shutdown = Boolean
        },
        setPriceRate: (state, priceRate) => {
            state.priceRate = priceRate
        },
    },
    actions: {
        setGlobalConfig: ({ commit }, item) => {
            commit('setGlobalConfig', item)
        },
        setTabIndex: ({ commit }, item) => {
            commit('setTabIndex', item)
        },
        setShutdown: ({ commit }, Boolean) => {
            commit('setShutdown', Boolean)
        },
        setPriceRate: ({ commit }, priceRate) => {
            commit('setPriceRate', priceRate)
        }
    },
    getters: {
        // desk数据
        getZendeskData: (state) => {
          return state.zendeskData
        },
        // 计价费率
        getPriceRate: function (state) {
            return state.priceRate
        },
        //停机维护状态
        isShutdown: function (state) {
            return state.shutdown
        },
        //红包开关（是否打开） 停机维护
        openReadPack: function (state) {
            return state.shutdown
        },
        //红包入口总开关（是否打开）
        showReadPack: function (state) {
            return !!(
                state.config.redPacketClosure &&
                state.config.redPacketClosure.value === 'false'
            )
        },
        //ctc开关（是否打开）
        showCtc: function (state) {
            return !!(
                state.config.c2cClosure &&
                state.config.c2cClosure.value === 'false'
            )
        },
        // 红包列表/我的红包
        redTabIndex: function (state) {
            return state.tabIndex || null
        },
        //币贷宝开关
        showLoans: function (state) {
            return !!(
                state.config.COIN_LOAN_DISPLAY_CLOSE &&
                state.config.COIN_LOAN_DISPLAY_CLOSE.value === 'false'
            )
        },
        //新pos矿池（hbt）开关
        isOpenHbt: function (state) {
            return !!(
                state.config.Hbt_Switch &&
                state.config.Hbt_Switch.value === 'false'
            )
        }
        
    }
}

export default global



// WEBPACK FOOTER //
// ./src/store/global/index.js